import { DecimalPipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'appIntegerTwoDecimal',
   standalone: true
})
export class AppIntegerTwoDecimalPipe implements PipeTransform {
   constructor(private decimalPipe: DecimalPipe) {}

   transform(val: any, allowNegative?: boolean): any {
      if (val == null) val = ''
      let numStr = val.toString().trim()

      if (numStr) {
         const isNegative = allowNegative && numStr[0] == '-'
         numStr = numStr.replace(/[^0-9.,]/g, '')

         let posDot = numStr.lastIndexOf('.')
         let posComma = numStr.lastIndexOf(',')
         if (posComma > posDot) {
            let numSplit = numStr.split('')
            numSplit[posComma] = '.'
            numStr = numSplit.join('')
            posDot = posComma
         }

         let numInt = ''
         let numDec = ''

         if (posDot == -1) {
            numInt = numStr
         } else {
            numInt = numStr.substring(0, posDot)
            numDec = numStr.substring(posDot + 1)
         }

         numInt = numInt ? numInt.replace(/[^0-9]/g, '') : '0'
         numDec = numDec ? numDec.replace(/[^0-9]/g, '').substring(0, 2) : '00'

         let numFloat = this.decimalPipe.transform(Number((isNegative ? '-' : '') + numInt + '.' + numDec), '1.2-2')
         numFloat = numFloat?.replace(/[,]/g, '') ?? '0.00'

         if (numFloat != '0.00') {
            return numFloat
         }
      }

      return '0.00'
   }
}
